const aggregateTypes = {
  FETCH_AGGREGATES: "FETCH_AGGREGATES",
  RESET_AGGREGATES: "RESET_AGGREGATES",
};

export default aggregateTypes;
